var $3154ac5122122e3b$exports = {};
const $3154ac5122122e3b$var$intersectionObserver = new IntersectionObserver((entries)=>{
    for (let entry of entries){
        if (entry.isIntersecting) {
            if (entry.target instanceof HTMLElement) {
                entry.target.style.opacity = "1";
                $3154ac5122122e3b$var$intersectionObserver.unobserve(entry.target);
            }
        }
    }
}, {
    root: null,
    rootMargin: "0px",
    threshold: 0
});
document.querySelectorAll("*[data-fade-in]").forEach((el)=>{
    el.style.opacity = "0";
    el.style.transitionProperty = `${el.style.transitionProperty} opacity`;
    el.style.transitionDuration = "1s";
    el.style.transitionTimingFunction = "ease-in-out";
    $3154ac5122122e3b$var$intersectionObserver.observe(el);
});


//# sourceMappingURL=index.fb0f5e45.js.map
